import {Component, Input} from '@angular/core';
import {Compbaser} from '../../../components/compbaser';
import {TranslocoService} from '@ngneat/transloco';
import {ToastrService} from "ngx-toastr";
import {AppService, AuthUserService, StoreSelectorsService} from "../../../services";
import {EnumLoginViewMode, IAppStatic, IUser} from "../../../interfaces";
import {actionAccountCommandsRequest, actionLoginViewMode} from "../../../store/actions/user.actions";
import {DialogPopComponent} from "../../../components/dialog-pop/dialog-pop.component";
import {timeout} from "../../../decorators/timeout";
import {MatDialog} from "@angular/material/dialog";
import {avoidPassCharacters, isHostLocal, isNullOrUndefOrEmpty, validateEmail} from "../../../common";

@Component({
    selector: 'app-change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.scss'],

})
export class ChangePasswordComponent extends Compbaser {
    m_loginName = '';
    m_pass = '';
    m_passNew = '';
    m_passRepeat = '';
    appStatic: IAppStatic;
    user: IUser;
    m_viewMod = EnumLoginViewMode;
    m_preFill = false;
    m_disableInput = false;
    m_user: IUser;

    @Input() hideBack = false;

    @Input()
    set preFill(i_enable: boolean) {
        if (!i_enable) return;
        this.m_preFill = true;
    }

    constructor(private translocoService: TranslocoService,
                public override dialog: MatDialog,
                private appService: AppService,
                private toastr: ToastrService,
                private storeSelector: StoreSelectorsService,
                private authUserService: AuthUserService) {
        super();
        this.cod(
            this.storeSelector.getAppSettings()
                .subscribe((i_appSettings: IAppStatic) => {
                    this.appStatic = i_appSettings;
                })
        );
    }

    ngOnInit() {
        this.cod(
            this.storeSelector.getUser()
                .subscribe((i_user: IUser) => {
                    if (!i_user || isNullOrUndefOrEmpty(i_user?.username))
                        return;
                    this.m_user = i_user;
                    if (this.m_preFill) {
                        if (validateEmail(this.m_user.email)) {
                            this.m_loginName = this.m_user.email;
                            this.m_disableInput = true;
                        } else if (validateEmail(this.m_user.username)) {
                            this.m_loginName = this.user.username;
                            this.m_disableInput = true;
                        }
                    }
                })
        );
    }

    setViewMode(v: EnumLoginViewMode) {
        this.storeSelector.dispatch(actionLoginViewMode({loginViewMode: v}));
        // this.m_currentViewMode = v;
    }

    onKeyUpPasswordDev() {
        if (isHostLocal()) {
            console.log(this.m_passNew);
        }
    }

    messageInvalidCharChosen(e) {
        switch (e.restriction) {
            case 'login': {
                this.toastr.error(this.translocoService.translate('toast.charNotAllowed', {}, this.translocoService.getActiveLang()) + ` <br/> A-Z 0-9 @ _ .`);
                break;
            }
            case 'password': {
                this.toastr.error(this.translocoService.translate('toast.pleaseAvoidChar', {}, this.translocoService.getActiveLang()) + avoidPassCharacters());
                break;
            }
            default: {
                this.toastr.error(this.translocoService.translate('toast.charNotAllowed', {}, this.translocoService.getActiveLang()) + ` ...`);
            }
        }
    }

    changePassword() {
        this.storeSelector.appStore.dispatch(actionAccountCommandsRequest({
                accountRequest: {
                    createCustomerAccount: {
                        userName: this.m_loginName,
                        password: this.m_pass,
                        newPass: this.m_passNew
                    },
                    serverCall: 'CHANGE_PASS'
                }
            })
        );
    }

    @timeout(333)
    logout() {
        this.authUserService.logout();
        setTimeout(() => {
            this.appService.goToHomePage(false);
        }, 1000);
    }

    onChangePassword() {
        const dialogRef = this.dialog.open(DialogPopComponent, {
            height: '200px',
            width: '400px',
            data: {
                name:
                    `${this.translocoService.translate('account.areYouSureThisLogout2', {}, this.translocoService.getActiveLang())}?`,
                showCancel: true
            }
        });
        dialogRef.afterClosed().subscribe((r) => {
            if (r) {
                if (this.m_passNew !== this.m_passRepeat)
                    return this.toastr.error(this.translocoService.translate('account.passwordMismatch', {}, this.translocoService.getActiveLang()));
                if (this.m_loginName.length < 3)
                    return this.toastr.error(this.translocoService.translate('account.emailMoreChar', {}, this.translocoService.getActiveLang()));
                if (this.m_pass.length < 3)
                    return this.toastr.error(this.translocoService.translate('account.origPassTooShort', {}, this.translocoService.getActiveLang()));
                if (this.m_passNew.length < 5)
                    return this.toastr.error(this.translocoService.translate('account.passTooShort', {}, this.translocoService.getActiveLang()));
                if (this.m_user && this.m_pass !== this.m_user.passwordNew)
                    return this.toastr.error(this.translocoService.translate('account.originalPasswordMismatch', {}, this.translocoService.getActiveLang()));
                this.m_loginName = this.m_loginName.trim();
                this.changePassword();
                this.toastr.info(this.translocoService.translate('toast.reLogin', {}, this.translocoService.getActiveLang()));
                this.logout();
            }
        });
    }
}


// onChangePasswordConfirm(): void {
//     const dialogRef = this.dialog.open(DialogPopComponent, {
//         height: '200px',
//         width: '400px',
//         data: {
//             name: `${this.translocoService.translate('general.changePassLogout', {}, this.translocoService.getActiveLang())}`,
//             showCancel: true
//         }
//     });
//     this.cod(
//         dialogRef.afterClosed().subscribe(result => {
//             if (!result) return;
//             this.changePassword();
//             this.m_pass = '';
//             this.m_passNew = '';
//             this.m_passRepeat = '';
//             this.logout();
//         })
//     );
// }
